import { TChangePaymentDayInfo } from '@r1-frontend/api-domru/api-profile/v1/payments/change-payment-day-info/dto/ResponseDto';
import { IPaymentInfo, IPersonal, IProducts } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { IAction } from '~/src/store';
import { EAuthTypes } from '~/src/store/actionTypes/auth';
import { IClientContacts } from '~/src/store/reducers/auth';

interface ILoginPayload {
    accessToken: string,
    refreshToken: string,
}
export const setLogin = (payload: ILoginPayload): IAction<EAuthTypes.LOGIN, ILoginPayload> => ({
    type: EAuthTypes.LOGIN,
    payload,
});

export const setErrorClientPayment = (isError: boolean | null): IAction<EAuthTypes.ERROR_CLIENT_PAYMENT, boolean | null> => ({
    type: EAuthTypes.ERROR_CLIENT_PAYMENT,
    payload: isError,
});

export const setFetchClientPayment = (isFetching: boolean | null): IAction<EAuthTypes.FETCH_CLIENT_PAYMENT, boolean | null> => ({
    type: EAuthTypes.FETCH_CLIENT_PAYMENT,
    payload: isFetching,
});


export const setLoginError = (error: string): IAction<EAuthTypes.SET_LOGIN_ERROR, string> => ({
    type: EAuthTypes.SET_LOGIN_ERROR,
    payload: error,
});

export const setClientPersonal = (personal: IPersonal): IAction<EAuthTypes.SET_CLIENT_PERSONAL, IPersonal> => ({
    type: EAuthTypes.SET_CLIENT_PERSONAL,
    payload: personal,
});

export const setClientPayment = (payment: IPaymentInfo): IAction<EAuthTypes.SET_CLIENT_PAYMENT, IPaymentInfo> => ({
    type: EAuthTypes.SET_CLIENT_PAYMENT,
    payload: payment,
});

export const setClientProducts = (products: IProducts): IAction<EAuthTypes.SET_CLIENT_PRODUCTS, IProducts> => ({
    type: EAuthTypes.SET_CLIENT_PRODUCTS,
    payload: products,
});

export const setClientContacts = (clientContacts: IClientContacts): IAction<EAuthTypes.SET_CLIENT_CONTACTS, IClientContacts> => ({
    type: EAuthTypes.SET_CLIENT_CONTACTS,
    payload: clientContacts,
});

export const clientContactsLoading = (isLoading: boolean): IAction<EAuthTypes.CLIENT_CONTACTS_LOADING, boolean> => ({
    type: EAuthTypes.CLIENT_CONTACTS_LOADING,
    payload: isLoading,
});

export const clientProductsLoading = (isLoading: boolean): IAction<EAuthTypes.CLIENT_PRODUCTS_LOADING, boolean> => ({
    type: EAuthTypes.CLIENT_PRODUCTS_LOADING,
    payload: isLoading,
});

export const setClientPaymentDayInfo = (
    dayInfo: TChangePaymentDayInfo,
): IAction<EAuthTypes.SET_PAYMENT_DAY_INFO, TChangePaymentDayInfo> => ({
    type: EAuthTypes.SET_PAYMENT_DAY_INFO,
    payload: dayInfo,
});

export const setCSRF = (
    token: string,
): IAction<EAuthTypes.SET_CSRF_TOKEN, string> => ({
    type: EAuthTypes.SET_CSRF_TOKEN,
    payload: token,
});
